
import { Component, Vue } from 'nuxt-property-decorator'
import { AlButton } from '~/components/ui'
import { getExternalCompareMobileHref } from '~/utils/external-links.utils'

@Component({
  components: { AlButton },
})
export default class CoverageBanner extends Vue {
  get externalCompareMobileHref (): string {
    return getExternalCompareMobileHref(this.$config.BASE_URL, this.localePath)
  }
}
